var _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25.748,
    y: 2.91421,
    width: 33,
    height: 33,
    rx: 5,
    transform: "rotate(45 25.748 2.91421)",
    stroke: "#999999",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 18,
    width: 1,
    height: 11,
    stroke: "#999999"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5,
    y: 33,
    width: 1,
    height: 1,
    stroke: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.cdebcbc8a5ed451c6427dbf3ceaa7f81.svg";
export { ForwardRef as ReactComponent };